export default function tabs() {

    function toggleTab(e) {
        var el = e.target;
        var tabButton = document.getElementsByClassName("tab__button");
        var tabContent = document.getElementsByClassName("tab__content");
        var contentTabID = el.getAttribute("tabcontent");

        for (var i = 0; i < tabContent.length; i++) {
            tabContent[i].className = "tab__content";
        }

        for (var i = 0; i < tabButton.length; i++) {
            tabButton[i].className = "tab__button";
        }
        
        el.className = "tab__button active";

        //Move the line based on what option is selected
        if (el.getAttribute('tabcontent') == 'tab2') {
            document.getElementById('slideline').setAttribute("style", "width: 160px; left: 162px;");
        } else {
            document.getElementById('slideline').setAttribute("style", "width: 160px; left: 0;");
        }

        document.getElementById(contentTabID).className += " activeTab";
        moveTabLine(el);
    }

    var tabButtons = document.getElementsByClassName('tab__button');
    var slideLine = document.getElementById("slideline");
    if (slideLine !== null) {
        //console.log("slideline not null");
        slideLine.style.width = tabButtons[0].offsetWidth + 'px';
    }
    for (var i = 0; i < tabButtons.length; i++) {
        tabButtons[i].addEventListener('click', toggleTab, false);
    }

    // Function to move menu slider left and right
    function moveTabLine(currentItem) {
        // console.log(currentItem);
        slideLine.style.width = currentItem.offsetWidth + 'px';
        slideLine.style.left = currentItem.offsetLeft + 'px';
    }

    function getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    }

    var vid = getUrlVars()["vid"];
    if (vid != undefined) {
        var link = document.querySelectorAll('.tab__button')[1];
        // console.log(link);
        toggleTab({target:link});
    }

    var selTab = getUrlVars()["tab"];
    if (selTab == 'vid') {
        var link2 = document.querySelectorAll('.tab__button')[1];
        console.log(link2);
        toggleTab({target:link2});
    }

    // Set tab indexes for menu items and sub menu items
    var toplevelMenuItems = document.querySelectorAll('#menu-main-menu > li > a');
    var submenuItems = document.querySelectorAll('.sub-menu > li > a');
    var mobileSubmenuItems = document.querySelectorAll('.mobileMenu__tabBar > .sub-menu > a');

    [...toplevelMenuItems].forEach(menuItem => menuItem.tabIndex = 0);
    [...toplevelMenuItems].forEach(menuItem => menuItem.ariaHasPopup = true);
    [...toplevelMenuItems].forEach(menuItem => menuItem.ariaExpanded = false);
    [...toplevelMenuItems].forEach(menuItem => menuItem.role = "menuItem");

    [...submenuItems].forEach(subMenuItem => subMenuItem.tabIndex = -1);
    [...submenuItems].forEach(subMenuItem => subMenuItem.role = "menu-item");

    [...mobileSubmenuItems].forEach(mobileSubmenuItem => mobileSubmenuItem.tabIndex = -1);
    [...mobileSubmenuItems].forEach(mobileSubmenuItem => mobileSubmenuItem.role = "menu-item");

}